import {SelectOptionType} from '@guestapp/sdk';
import {AddFormType, AddFormV2Type} from '../../../context/guest';
import {FORM_NAMES} from '../../../utils/guestForm';
import {getIsSelectFieldType} from './common';

type HandleChangeLocation = {
  newValue: SelectOptionType | null;
  formFields: AddFormType | AddFormV2Type;
  onReset: (fieldName: string) => void;
  currentValue?: string;
};
const handleChangeResidenceCountry = ({
  newValue,
  currentValue,
  onReset,
  formFields,
}: HandleChangeLocation) => {
  const isValueChanged = newValue?.value !== currentValue;

  const shouldResetCity =
    getIsSelectFieldType(formFields?.[FORM_NAMES.residence_city]?.type) && isValueChanged;

  const shouldResetProvince =
    getIsSelectFieldType(formFields?.[FORM_NAMES.residence_province]?.type) &&
    isValueChanged;

  if (shouldResetCity) {
    onReset(FORM_NAMES.residence_city);
  }
  if (shouldResetProvince) {
    onReset(FORM_NAMES.residence_province);
  }
};

const handleChangeResidenceProvince = ({
  newValue,
  currentValue,
  onReset,
  formFields,
}: HandleChangeLocation) => {
  const shouldResetCity =
    getIsSelectFieldType(formFields?.[FORM_NAMES.residence_city]?.type) &&
    newValue?.value !== currentValue;

  if (shouldResetCity) {
    onReset(FORM_NAMES.residence_city);
  }
};

export {handleChangeResidenceCountry, handleChangeResidenceProvince};
